import o from"styled-components";import{theme as t}from"../../../theme.js";const r=o.div`
  width: ${e=>e.size}px;
  height: ${e=>e.size}px;
  border-radius: 50%;
  background-color: ${t.colors.gray[200]};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
  > span {
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${e=>e.fontSize}px;
    color: ${t.colors.secondary[900]};
  }
`;export{r as Container};
